import React from 'react'
import { Link } from 'react-router-dom'

import { Logo } from 'components/images/logo';
import 'components/styles/main.scss';

export const App = () => {
  return (
    <div className="main">
      <h1>A Rasa Hosted Page!</h1>
      <Logo/>
      <div>
        <ul>
          <li><Link to="/engagement">Dashboard</Link></li>
          <li><Link to="/topics">Topic Cloud</Link></li>
        </ul>
      </div>
    </div>
  );
}
